import { Api, ApiGetGeoUnitsRequestFromJSON, ApiItemType, ApiGetDescriptionDataRequestFromJSON, ApiSearchRentalCarStationsRequestFromJSON, ApiConfigurationDataRequestFromJSON, ApiConfigurationDataType, ApiConfigurationDataFilterFromJSON } from '@ibe/api';
import object_hash from '../../../../../node_modules/.pnpm/object-hash@2.2.0/node_modules/object-hash/dist/object_hash.js';
import LoggerFactory from '../../Util/Logger/LoggerFactory.js';
import { ItemType } from '../../Models/Items/Item.js';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
// must live outside ApiService, because ApiService will be re-recreated all the time
var packageCache = {};
var geoUnitCache = {};
var ApiService = /*#__PURE__*/function (_Api) {
  _inherits(ApiService, _Api);
  var _super = _createSuper(ApiService);
  function ApiService() {
    var _this;
    _classCallCheck(this, ApiService);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.logger = LoggerFactory.get('ApiService');
    return _this;
  }
  _createClass(ApiService, [{
    key: "searchPackagesCached",
    value: function () {
      var _searchPackagesCached = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var hash;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              hash = object_hash(request);
              if (Object.prototype.hasOwnProperty.call(packageCache, hash)) {
                _context.next = 12;
                break;
              }
              _context.prev = 2;
              _context.next = 5;
              return this.searchPackages(request);
            case 5:
              packageCache[hash] = _context.sent;
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              delete packageCache[hash];
              throw _context.t0;
            case 12:
              return _context.abrupt("return", packageCache[hash]);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 8]]);
      }));
      function searchPackagesCached(_x) {
        return _searchPackagesCached.apply(this, arguments);
      }
      return searchPackagesCached;
    }()
  }, {
    key: "getHotelGeoUnits",
    value: function () {
      var _getHotelGeoUnits = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.fetchOnce(geoUnitCache, 'hotelGeoUnits', function () {
                var request = ApiGetGeoUnitsRequestFromJSON({
                  type: 'GetGeoUnitsRequest',
                  itemType: ItemType.Hotel.toLocaleUpperCase() // TODO adjust enum to save the toUpper, can be removed, shall be defined in backend
                });
                return _this2.getGeoUnits(request);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getHotelGeoUnits() {
        return _getHotelGeoUnits.apply(this, arguments);
      }
      return getHotelGeoUnits;
    }()
  }, {
    key: "getOriginAirportGeoUnits",
    value: function () {
      var _getOriginAirportGeoUnits = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.fetchOnce(geoUnitCache, 'origins', function () {
                return _this3.getOriginAirports(ApiGetGeoUnitsRequestFromJSON({
                  type: 'GetGeoUnitsRequest',
                  itemType: ApiItemType.TRANSPORT
                }));
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getOriginAirportGeoUnits() {
        return _getOriginAirportGeoUnits.apply(this, arguments);
      }
      return getOriginAirportGeoUnits;
    }()
  }, {
    key: "getDestinationAirportGeoUnits",
    value: function () {
      var _getDestinationAirportGeoUnits = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this4 = this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", this.fetchOnce(geoUnitCache, 'destinations', function () {
                return _this4.getDestinationAirports(ApiGetGeoUnitsRequestFromJSON({
                  type: 'ApiGetGeoUnitsRequest',
                  itemType: ApiItemType.TRANSPORT
                }));
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getDestinationAirportGeoUnits() {
        return _getDestinationAirportGeoUnits.apply(this, arguments);
      }
      return getDestinationAirportGeoUnits;
    }()
  }, {
    key: "getTermsAndConditionsForService",
    value: function () {
      var _getTermsAndConditionsForService = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(type, serviceCode) {
        var request;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              request = ApiGetDescriptionDataRequestFromJSON({
                code: serviceCode,
                type: type,
                descriptionCategoryType: 'TC'
              });
              return _context5.abrupt("return", this.getServiceDescriptionData(request));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getTermsAndConditionsForService(_x2, _x3) {
        return _getTermsAndConditionsForService.apply(this, arguments);
      }
      return getTermsAndConditionsForService;
    }()
  }, {
    key: "getTermsAndConditionsForUnit",
    value: function () {
      var _getTermsAndConditionsForUnit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(serviceType, serviceCode, unitType, unitCode) {
        var request;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              request = ApiGetDescriptionDataRequestFromJSON({
                code: unitCode,
                type: unitType,
                parentCode: serviceCode,
                parentType: serviceType,
                descriptionCategoryType: 'TC'
              });
              return _context6.abrupt("return", this.getServiceUnitDescriptionData(request));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getTermsAndConditionsForUnit(_x4, _x5, _x6, _x7) {
        return _getTermsAndConditionsForUnit.apply(this, arguments);
      }
      return getTermsAndConditionsForUnit;
    }()
  }, {
    key: "getGeoUnitsForItemType",
    value: function () {
      var _getGeoUnitsForItemType = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(itemType) {
        var request;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              request = ApiGetGeoUnitsRequestFromJSON({
                type: 'GetGeoUnitsRequest',
                itemType: itemType
              });
              return _context7.abrupt("return", this.getGeoUnits(request));
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getGeoUnitsForItemType(_x8) {
        return _getGeoUnitsForItemType.apply(this, arguments);
      }
      return getGeoUnitsForItemType;
    }()
  }, {
    key: "getPackageServiceGeoUnits",
    value: function () {
      var _getPackageServiceGeoUnits = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var request;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              request = ApiGetGeoUnitsRequestFromJSON({
                type: 'GetGeoUnitsRequest',
                itemType: ApiItemType.PACKAGE
              });
              return _context8.abrupt("return", this.getGeoUnits(request));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getPackageServiceGeoUnits() {
        return _getPackageServiceGeoUnits.apply(this, arguments);
      }
      return getPackageServiceGeoUnits;
    }()
  }, {
    key: "getRentalCarGeoUnits",
    value: function () {
      var _getRentalCarGeoUnits = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var request;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              request = ApiGetGeoUnitsRequestFromJSON({
                type: 'GetGeoUnitsRequest',
                itemType: ApiItemType.CAR
              });
              return _context9.abrupt("return", this.getGeoUnits(request));
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getRentalCarGeoUnits() {
        return _getRentalCarGeoUnits.apply(this, arguments);
      }
      return getRentalCarGeoUnits;
    }()
  }, {
    key: "loadStep",
    value: function loadStep(apiWorkflowStepRequest) {
      this.logger.warn('ATTENTION: YOU ARE USING A MOCKED API!');
      return _superPropGet(ApiService, "loadStep", this, 3)([apiWorkflowStepRequest]);
    }
  }, {
    key: "searchRentalCarStationsService",
    value: function () {
      var _searchRentalCarStationsService = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(value) {
        var request;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              request = ApiSearchRentalCarStationsRequestFromJSON({
                searchExpression: value
              });
              return _context10.abrupt("return", this.searchRentalCarStations(request));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function searchRentalCarStationsService(_x9) {
        return _searchRentalCarStationsService.apply(this, arguments);
      }
      return searchRentalCarStationsService;
    }()
  }, {
    key: "getCountriesWithChildren",
    value: function () {
      var _getCountriesWithChildren = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.getCountries());
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getCountriesWithChildren() {
        return _getCountriesWithChildren.apply(this, arguments);
      }
      return getCountriesWithChildren;
    }()
  }, {
    key: "getSalutations",
    value: function () {
      var _getSalutations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var request;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.SALUTATIONS]
              });
              return _context12.abrupt("return", this.getConfiguration(request));
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getSalutations() {
        return _getSalutations.apply(this, arguments);
      }
      return getSalutations;
    }()
  }, {
    key: "getAllCountries",
    value: function () {
      var _getAllCountries = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(languageCode) {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.COUNTRIES]
              });
              if (!!languageCode) {
                request = _objectSpread(_objectSpread({}, request), {}, {
                  languageCode: languageCode
                });
              }
              _context13.next = 4;
              return this.getConfiguration(request);
            case 4:
              res = _context13.sent;
              return _context13.abrupt("return", res.data[ApiConfigurationDataType.COUNTRIES].sort(function (c1, c2) {
                return c1.description.localeCompare(c2.description);
              }));
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getAllCountries(_x10) {
        return _getAllCountries.apply(this, arguments);
      }
      return getAllCountries;
    }()
  }, {
    key: "getCitiesAndCountriesFromPostalCode",
    value: function () {
      var _getCitiesAndCountriesFromPostalCode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(postalCodes, countryCodes, languageCode) {
        var _yield$this$getConfig, _yield$this$getConfig2;
        var request;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.POSTALCODE],
                languageCode: languageCode,
                elementFilters: [ApiConfigurationDataFilterFromJSON({
                  element: ApiConfigurationDataType.POSTALCODE,
                  codes: postalCodes
                })].concat(_toConsumableArray(!!countryCodes ? [ApiConfigurationDataFilterFromJSON({
                  element: ApiConfigurationDataType.COUNTRIES,
                  codes: countryCodes
                })] : []))
              });
              _context14.next = 3;
              return this.getConfiguration(request);
            case 3:
              _context14.t1 = _yield$this$getConfig = _context14.sent;
              _context14.t0 = _context14.t1 === null;
              if (_context14.t0) {
                _context14.next = 7;
                break;
              }
              _context14.t0 = _yield$this$getConfig === void 0;
            case 7:
              if (!_context14.t0) {
                _context14.next = 11;
                break;
              }
              _context14.t2 = void 0;
              _context14.next = 12;
              break;
            case 11:
              _context14.t2 = (_yield$this$getConfig2 = _yield$this$getConfig.data) === null || _yield$this$getConfig2 === void 0 ? void 0 : _yield$this$getConfig2[ApiConfigurationDataType.POSTALCODE];
            case 12:
              return _context14.abrupt("return", _context14.t2);
            case 13:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getCitiesAndCountriesFromPostalCode(_x11, _x12, _x13) {
        return _getCitiesAndCountriesFromPostalCode.apply(this, arguments);
      }
      return getCitiesAndCountriesFromPostalCode;
    }()
  }, {
    key: "getNationalities",
    value: function () {
      var _getNationalities = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.NATIONALITIES]
              });
              _context15.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context15.sent;
              return _context15.abrupt("return", res.data[ApiConfigurationDataType.NATIONALITIES].sort(function (c1, c2) {
                return c1.description.localeCompare(c2.description);
              }));
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getNationalities() {
        return _getNationalities.apply(this, arguments);
      }
      return getNationalities;
    }()
  }, {
    key: "getCountryRegions",
    value: function () {
      var _getCountryRegions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var request, res, resultMap, countries, countryRegions, findKey;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.COUNTRYREGIONS, ApiConfigurationDataType.COUNTRIES]
              });
              _context16.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context16.sent;
              resultMap = new Map();
              countries = res.data[ApiConfigurationDataType.COUNTRIES];
              countryRegions = res.data[ApiConfigurationDataType.COUNTRYREGIONS] || new Array();
              countries.forEach(function (value) {
                resultMap.set(value, []);
              });
              findKey = function findKey(code) {
                return countries.find(function (v) {
                  return v.code === code;
                });
              };
              countryRegions.forEach(function (value) {
                if (value.group) {
                  var key = findKey(value.group);
                  if (key) {
                    var _resultMap$get;
                    (_resultMap$get = resultMap.get(key)) === null || _resultMap$get === void 0 ? void 0 : _resultMap$get.push(value);
                  }
                }
              });
              return _context16.abrupt("return", resultMap);
            case 11:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getCountryRegions() {
        return _getCountryRegions.apply(this, arguments);
      }
      return getCountryRegions;
    }()
  }, {
    key: "getAllLanguages",
    value: function () {
      var _getAllLanguages = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.LANGUAGES]
              });
              _context17.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context17.sent;
              return _context17.abrupt("return", res.data[ApiConfigurationDataType.LANGUAGES]);
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getAllLanguages() {
        return _getAllLanguages.apply(this, arguments);
      }
      return getAllLanguages;
    }()
  }, {
    key: "getAllCurrencies",
    value: function () {
      var _getAllCurrencies = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.CURRENCIES]
              });
              _context18.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context18.sent;
              return _context18.abrupt("return", res.data[ApiConfigurationDataType.CURRENCIES]);
            case 5:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function getAllCurrencies() {
        return _getAllCurrencies.apply(this, arguments);
      }
      return getAllCurrencies;
    }()
  }, {
    key: "getServiceUnitTypeCodes",
    value: function () {
      var _getServiceUnitTypeCodes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee19(itemType) {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.UNITTYPE],
                itemType: itemType
              });
              _context19.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context19.sent;
              return _context19.abrupt("return", res.data[ApiConfigurationDataType.UNITTYPE]);
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getServiceUnitTypeCodes(_x14) {
        return _getServiceUnitTypeCodes.apply(this, arguments);
      }
      return getServiceUnitTypeCodes;
    }()
  }, {
    key: "getServiceGroups",
    value: function () {
      var _getServiceGroups = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee20(itemType) {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.SERVICEGROUP],
                itemType: itemType
              });
              _context20.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context20.sent;
              return _context20.abrupt("return", res.data[ApiConfigurationDataType.SERVICEGROUP]);
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getServiceGroups(_x15) {
        return _getServiceGroups.apply(this, arguments);
      }
      return getServiceGroups;
    }()
  }, {
    key: "getCabinClasses",
    value: function () {
      var _getCabinClasses = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var request, res;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              request = ApiConfigurationDataRequestFromJSON({
                typeCodes: [ApiConfigurationDataType.CABINCLASS]
              });
              _context21.next = 3;
              return this.getConfiguration(request);
            case 3:
              res = _context21.sent;
              return _context21.abrupt("return", res.data[ApiConfigurationDataType.CABINCLASS]);
            case 5:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getCabinClasses() {
        return _getCabinClasses.apply(this, arguments);
      }
      return getCabinClasses;
    }() // do not use this when expecting varying responses
  }, {
    key: "fetchOnce",
    value: function () {
      var _fetchOnce = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee22(cache, key, request) {
        var configDependedKey;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              // because auth and language will change during runtime
              configDependedKey = "".concat(key, "_").concat(object_hash(this.configuration));
              if (Object.prototype.hasOwnProperty.call(cache, configDependedKey)) {
                _context22.next = 4;
                break;
              }
              _context22.next = 4;
              return ApiService.setCache(cache, configDependedKey, request() /* promise */);
            case 4:
              return _context22.abrupt("return", cache[configDependedKey]);
            case 5:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function fetchOnce(_x16, _x17, _x18) {
        return _fetchOnce.apply(this, arguments);
      }
      return fetchOnce;
    }()
  }], [{
    key: "setCache",
    value: function setCache(cache, key, value) {
      var cacheRef = cache;
      cacheRef[key] = value;
      return cacheRef[key];
    }
  }]);
  return ApiService;
}(Api);

export { ApiService as default };
//# sourceMappingURL=ApiService.js.map
